import { configureStore } from '@reduxjs/toolkit';

import rootReducer from './rootReducer';

import type { ApiClient } from '@travel/api-client';
import type { History } from 'history';
import type { RootState } from 'react-redux';
import type { Request, Response } from 'express';

export default function createAppStore({
  preloadedState,
  history,
  req,
  res,
  apiClient,
}: {
  preloadedState?: Partial<RootState>;
  history?: History;
  req?: Request;
  res?: Response;
  apiClient?: ApiClient;
}) {
  const initialState = preloadedState ?? {};

  return configureStore({
    reducer: rootReducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: { history, undefined, req, res, apiClient },
        },
        serializableCheck: false,
      }),
  });
}
